import {BaseEntity} from '../common/base-entity';

export class AcceptTermsConditions extends BaseEntity {
    id : number;
    termsAndConditions : string;
    createdDate: Date;
}
